import React from 'react';

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="font-serif text-xl text-charcoal-900 mb-2">{title}</h2>
    <div className="text-sm leading-relaxed text-charcoal-800/70 space-y-2">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-cream-50" data-testid="privacy-policy-page">
      <main className="max-w-3xl mx-auto px-5 py-10 sm:py-14">
        <h1 className="font-serif text-3xl sm:text-4xl text-charcoal-900 mb-2">Privacy Policy</h1>
        <p className="text-sm text-charcoal-800/50 mb-10">Piczoo Photobooths · Last updated June 2026 · Governed by the Digital Personal Data Protection Act, 2023 (India)</p>

        <Section title="What we collect, and why">
          <p><strong>Your photos.</strong> The photo strip and individual photos taken at the booth are stored securely so you can download them from your personal link. They are <strong>automatically deleted 48 hours</strong> after printing.</p>
          <p><strong>Your WhatsApp number and name (optional, with your consent).</strong> If you choose to share them on the download page, we use them to send you your photos, offers, and event invites from Piczoo. Sharing them is voluntary — you can skip it and still download your photos.</p>
          <p><strong>Payment information.</strong> Payments are processed by Razorpay. We never see or store your UPI PIN, card number, or bank credentials — we only receive a payment confirmation and reference ID for the amount you paid at the booth.</p>
        </Section>

        <Section title="What we do NOT do">
          <p>We do not sell, rent, or share your personal data with any third party for their marketing. We do not use your photos for advertising or AI training. We do not track you across other websites.</p>
        </Section>

        <Section title="How long we keep your data">
          <p>Photos: deleted automatically 48 hours after printing. Contact details: kept until you ask us to remove them or withdraw consent. Payment records: retained as required by Indian tax and financial regulations.</p>
        </Section>

        <Section title="Your rights (DPDP Act, 2023)">
          <p>You have the right to: access a summary of the personal data we hold about you; correct or erase it; withdraw your consent at any time (message us &ldquo;STOP&rdquo; on WhatsApp or email us); nominate someone to exercise these rights on your behalf; and raise a grievance with us or the Data Protection Board of India.</p>
        </Section>

        <Section title="Security">
          <p>Data is stored on encrypted, access-controlled infrastructure in secure cloud data centres. Download links are unique per session and expire together with your photos.</p>
        </Section>

        <Section title="Contact & grievances">
          <p>For any privacy request, correction, deletion, or complaint, contact us at <a className="underline" href="mailto:click@piczoo.in">click@piczoo.in</a>. We aim to respond within 7 days.</p>
        </Section>

        <p className="text-xs text-charcoal-800/40 mt-10">© Piczoo. This policy applies to the Piczoo photobooth kiosks, the photo download service, and piczoo.in.</p>
      </main>
    </div>
  );
}
